<template>
    <div>
        <div class="row pt-4">
            <div class="col-md-12">
                <h2>Jadwal & Status Ujian Proposal</h2>
                <!-- Start Matkul -->
                <div v-if="collapse1">
                    <KTCodePreview :title="'Dosen Penguji'">
                        <template v-slot:toolbar>
                            <div class="pt-2" @click="opencard1(false)" style="cursor: pointer;">
                                <b-iconstack font-scale="2" rotate="270">
                                    <b-icon stacked icon="chevron-right" shift-h="0" variant="dark"></b-icon>
                                </b-iconstack>
                            </div>
                        </template>

                        <template v-slot:body>
                            <div>
                                <v-card-title class="d-flex flex-row justify-content-between align-items-center">
                                    <v-spacer></v-spacer>
                                    <v-text-field v-model="penguji.search" label="Search" single-line hide-details></v-text-field>
                                </v-card-title>
                                <v-data-table :headers="penguji.headers" :items="penguji.data" :search="penguji.search">
                                    <template v-slot:item.no="{ item }">
                                        {{ item.no }}
                                    </template>
                                    <template v-slot:item.jadwal="{ item }">
                                        <span v-for="(data, index) in item.jadwal.split('~')" :key="index">
                                            {{ (isValidDate(data)) ? formattedDate(data) : data }}<br>
                                        </span>
                                    </template>
                                    <template v-slot:item.action="{ item }">
                                        <ButtonComponent colors="#fff" name="eye-schedule" v-b-modal.modal @click.native="openModal(item)" />
                                            <!-- @click.native="redirectToDetail(item.id_proposal)" -->
                                    </template>
                                </v-data-table>
                            </div>
                        </template>
                        
                    </KTCodePreview>
                </div>
                <div v-show="collapse1 === false">
                    <div class="card card-custom gutter-b">
                        <div class="card-header" @click="opencard1(true)"  style="cursor: pointer;">
                            <div class="card-title">
                                <slot name="title"></slot>
                                <h3 class="card-label">
                                    Dosen Mata Kuliah
                                </h3>
                            </div>
                            <div class="pt-4">
                                <b-iconstack font-scale="2" rotate="90">
                                    <b-icon stacked icon="chevron-right" shift-h="0" variant="dark"></b-icon>
                                </b-iconstack>
                            </div>
                        </div>
                    </div>
                </div>
                
                <!-- Start Pembimbing Akademik-->
                <div v-if="collapse2">
                    <KTCodePreview :title="'Dosen Pembimbing'">
                        <template v-slot:toolbar>
                            <div class="pt-2" @click="opencard2(false)" style="cursor: pointer;">
                                <b-iconstack font-scale="2" rotate="270">
                                    <b-icon stacked icon="chevron-right" shift-h="0" variant="dark"></b-icon>
                                </b-iconstack>
                            </div>
                        </template>

                        <template v-slot:body>
                        <div>
                            <v-data-table :headers="dosbing.headers" :items="dosbing.data" :search="dosbing.search">
                                <template v-slot:item.no="{ item }">
                                    {{ item.no }}
                                </template>
                                <template v-slot:item.file="{ item }">
                                    <div class="box-custom text-center" v-if="item.file">
                                        <a @click='handleButtonClick(`${$endpoint}uploads/proposal/${item.file}`)' style="cursor: pointer;">{{ item.file }}</a>
                                    </div>
                                    <div class="text-center font-weight-bold" v-else>-</div>
                                </template>
                                <template v-slot:item.penguji="{ item }">
                                    <span v-for="(data, index) in item.penguji.split('~')" :key="index">
                                        {{ data }}<br>
                                    </span>
                                </template>
                            </v-data-table>
                        </div>
                    </template>
                        
                    </KTCodePreview>
                </div>
                <div v-show="collapse2 === false">
                    <div class="card card-custom gutter-b">
                        <div class="card-header" @click="opencard2(true)"  style="cursor: pointer;">
                            <div class="card-title">
                                <slot name="title"></slot>
                                <h3 class="card-label">
                                    Bimbingan Akademik
                                </h3>
                            </div>
                            <div class="pt-4">
                                <b-iconstack font-scale="2" rotate="90">
                                    <b-icon stacked icon="chevron-right" shift-h="0" variant="dark"></b-icon>
                                </b-iconstack>
                            </div>
                        </div>
                    </div>
                </div>

                <b-modal @ok="onSubmit" ok-title="Simpan" ok-variant="primary" no-enforce-focus cancel-title="Batal"
                    cancel-variant="danger" id="modal" size="xl" title="Detail" hide-footer>
                    <div class="container">
                        <v-data-table :headers="dataModal.headers" :items="dataModal.data">
                            <template v-slot:item.file="{ item }">
                              <div class="box-custom text-center">
                                    <a @click='handleButtonClick(`${$endpoint}uploads/file_revisi_skripsi/${item.file}`)' style="cursor: pointer;">{{ item.file }}</a>
                              </div>
                            </template>
                        </v-data-table>
                    </div>
                </b-modal>
            </div>
        </div>
    </div>
</template>

<script>
import KTCodePreview from "@/view/content/CardContent.vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import ButtonComponent from "@/view/content/components/button/buttonComponent.vue";
// import SelectComponent from "@/view/content/components/select/SelectComponent.vue";
import axios from "axios";
export default {
    name: 'SiakNgFrontEndPenugasanDosen',

    data() {
        return {
            penguji: {
                headers: [
                    { text: "No", value: "no", align: "center", sortable: false ,class: "header-color"},
                    { text: "Jadwal", value: "jadwal" ,class: "header-color"},
                    { text: "Ruangan", value: "ruangan" ,class: "header-color"},
                    { text: "Jumlah", value: "jumlah" ,class: "header-color"},
                    { text: "Aksi", value: "action" ,class: "header-color"},
                ],
                data: [],
                search: "",
            },
            dosbing: {
                headers: [
                    { text: "No", value: "no", align: "center", sortable: false ,class: "header-color"},
                    { text: "NIM", value: "nim" ,class: "header-color"},
                    { text: "Nama", value: "nama" ,class: "header-color"},
                    { text: "Angkatan", value: "angkatan" ,class: "header-color"},
                    { text: "Judul Skripsi", value: "judul" ,class: "header-color", width: '20%'},
                    { text: "File Proposal", value: "file" ,class: "header-color"},
                    { text: "Jadwal", value: "jadwal" ,class: "header-color"},
                    { text: "Dosen Penguji", value: "penguji" ,class: "header-color"},
                    // { text: "Aksi", value: "action" },
                ],
                data: [],
                search: "",
                dataAngkatan: [
                    { id: null, text: '--Pilih Angkatan--' },
                ],
                selectedAngkatan: null,
                dataProdi: [
                    { id: null, text: '--Pilih Prodi--' },
                ],
                selectedProdi: null,
                listKelas: [
                    { id: null, text: '--Pilih Kelas--' },
                ],
                selectedKelas: null,
                student: [],
                listStudent: [
                    { id: null, text: '--Pilih Student--' },
                ],
                selectedStudent: null,
                dataStudent: {
                    nama:null,
                    pangkat: null,
                },
            },
            dataModal: {
                headers: [
                    { text: "No", value: "no", align: "center", sortable: false, width: '3%', class: "header-color"},
                    { text: "NIM", value: "nim", class: "header-color", width: '5%', sortable: false,},
                    { text: "Nama", value: "nama" , class: "header-color", width: '15%', sortable: false,},
                    { text: "Angkatan", value: "angkatan", class: "header-color" , width: '5%', sortable: false,},
                    { text: "Judul Skripsi", value: "judul", class: "header-color", width: '35%', sortable: false,},
                    { text: "Dosen Pembimbing", value: "dosen" , class: "header-color", width: '20%', sortable: false,},
                    { text: "File", value: "file" , class: "header-color", width: '15%', sortable: false,},
                    // { text: "Aksi", value: "action", align: "center", sortable: false , class: "header-color" },
                ],
                data: [],
                search: "",
            },
            dataTahun: [
                { id: null, text: '--Pilih Tahun Akademik--' },
            ],
            selectedTahunAkademik: null,
            selectedTahunTA: null,
            selectedTahunMatkul: null,
            dataLecturer: null,
            dis: false,
            disTA: false,
            akademik: [],
            collapse1: true,
            collapse2: true,
            collapse3: true
        };
    },

    components: {
      KTCodePreview,
      ButtonComponent,
    //   SelectComponent
    },

    async mounted() {
        this.$store.dispatch(SET_BREADCRUMB, [
            { title: "Penilaian" },
        ]);

        this.dataLecturer = JSON.parse(localStorage.getItem('dataLogin'));
        this.loadData();
    },

    methods: {
        async handleButtonClick(fileUrl){
            const response = await fetch(fileUrl, {
                method: 'HEAD'
            });

            if (!response.ok) {
                this.$swal(`File Tidak Tersedia`);
            }else{
                window.open(fileUrl, '_blank');
            }
        },
        async openModal() {
            if (this.dataModal.data.length > 0) {
                this.dataModal.data = []
            }
            const modal = await axios.get(`pengajuan-skripsi/dosen/dosen-penguji/list-siswa/${this.dataLecturer.key_dosen}`);
            modal.data.data.map((data, index) => {
                let obj = {
                    key: data.student_key,
                    no: index+1,
                    nim: data.nim,
                    nama: data.name,
                    angkatan: data.angkatan,
                    judul: data.judul,
                    dosen: data.dosen_pembimbing,
                    file: data.file_skripsi,
                }
                this.dataModal.data.push(obj);
            })
        },
        loadData() {
            const data1 = this.getDataPenguji();
            const data2 = this.getDataDosBing();
            Promise.all([data1, data2]);
        },
        opencard1(status){
            this.collapse1 = status;
        },
        opencard2(status){
            this.collapse2 = status;
        },
        opencard3(status){
            this.collapse3 = status;
        },
        addRowDosningAkademik(text) {
            if (text == 'akademik') {
                let no = this.dosbing.data.length + 1;
                let data = {
                    key: null,
                    no: no,
                    angkatan: null,
                    prodi: null,
                    komkel: null,
                    key_student: null,
                    nama: null,
                    nim: null,
                    pangkat: null,
                    action: true,
                };
                this.dis = true;
                this.dosbing.data.push(data);
            }else{
                let no = this.dosenTA.data.length + 1;
                let data = {
                    key: null,
                    no: no,
                    angkatan: null,
                    prodi: null,
                    komkel: null,
                    key_student: null,
                    nama: null,
                    nim: null,
                    pangkat: null,
                    action: true,
                };
                this.disTA = true;
                this.dosenTA.data.push(data);
            }
        },
        
        async getDataTahun() {
            try {
                const response = await axios.get('master/generations');
                if (response.status === 200) {
                    response.data.data.forEach((e) => {
                        if (e.status === true) {
                            var object = { id: e.key, text: `Tahun ${e.tahun} / ${e.tahun_akhir} - ${e.semester}` };
                            this.dataTahun.push(object);
                        }
                        // if (index >= response.data.data.length - 1) {
                        //     const currentYear = new Date().getFullYear();
                        //     let find = this.dataTahun.find(item => item.text === `Tahun ${currentYear} / ${currentYear + 1}`);
                            // this.selectedTahun = find ? find.id : null;
                            // this.selectedTahunMatkul = this.selectedTahun;
                            // this.selectedTahunMatkul = find.id;
                            // this.selectedTahunAkademik = find.id;
                            // this.selectedTahunTA = find.id;
                        // }
                    });
                    this.sortedTahun();
                }
            } catch (error) {
                throw error;
            }
        },

        sortedTahun() {
            this.dataTahun.sort((a, b) => {
                if (b.text < a.text) return -1;
                if (b.text > a.text) return 1;
                return 0;
            });
        },


        async getDataAngkatan(tahun, text){
            if (text == 'akademik') {
                if (this.dosbing.dataAngkatan.length > 0) {
                    this.dosbing.dataAngkatan = []
                }
            }else{
                if (this.dosenTA.dataAngkatan.length > 0) {
                    this.dosenTA.dataAngkatan = []
                }
            }
            await axios.get('master/angkatan?status=true')
                .then(res => {
                    if (res.status == 200) {
                        res.data.data.map((angk, index) => {
                            if (angk.key_tahun == tahun) {
                                var data = { id: angk.key, text: angk.nama_angkatan }
                                if (text == 'akademik') {
                                    this.dosbing.dataAngkatan.push(data);
                                }else{
                                    this.dosenTA.dataAngkatan.push(data);
                                }
                                return index > res.data.data.length - 1
                            }
                        })
                    }
                })
        },

        async getDataProdi(text){
            if (text == 'akademik') {
                if (this.dosbing.dataProdi.length > 0) {
                    this.dosbing.dataProdi = []
                }
            }else{
                if (this.dosenTA.dataAngkatan.length > 0) {
                    this.dosenTA.dataProdi = []
                }
            }
            await axios.get('master/study-programs')
                .then(res => {
                    if (res.status == 200) {
                        res.data.data.map((prod, index) => {
                            var data = { id: prod.key, text: prod.program_name }
                            if (text == 'akademik') {
                                this.dosbing.dataProdi.push(data);
                            }else{
                                this.dosenTA.dataProdi.push(data);
                            }
                            return index > res.data.data.length - 1
                        })
                    }
                })
        },

        async getDataKelas(prodi, text) {
            if (text == 'akademik') {
                if (this.dosbing.listKelas.length > 0) {
                    this.dosbing.listKelas = []
                }
            }else{
                if (this.dosenTA.listKelas.length > 0) {
                    this.dosenTA.listKelas = []
                }
            }
            try {
                await axios.get(`master/student-group`)
                .then(response => {
                    if (response.status == 200) {
                    response.data.data.some((e, index) => {
                        var object = { id: e.key, text: e.nama_kelompok }
                        if (e.prodi_id == prodi) {
                            if (text == 'akademik') {
                                this.dosbing.listKelas.push(object);
                            }else{
                                this.dosenTA.listKelas.push(object);
                            }
                        }
                        return index > response.data.data.length - 1;
                    });
                    }
                });
            } catch (err) {
                this.$swal(`Failed`);
            }
        },

        async getDataSiswa(angkatan, prodi, komkel, komp){
            if (komp == 'akademik') {
                if (this.dosbing.student.length > 0) {
                    this.dosbing.student = []
                    this.dosbing.listStudent = []
                }
            }else{
                if (this.dosenTA.student.length > 0) {
                    this.dosenTA.student = []
                    this.dosenTA.listStudent = []
                }
            }
            await axios.get(`master/penugasan-dosen/get-student?angkatan=${angkatan}&prodi=${prodi}&kelompok=${komkel}`)
                .then(res => {
                    res.data.data.map((std, index) => {
                        let obj = {
                            key: std.key,
                            nama_pangkat: std.nama_pangkat,
                            nim: std.nim,
                            student_name: std.student_name,
                        };
                        var stud = { id: std.key, text: std.student_name };
                        if (komp == 'akademik') {
                            this.dosbing.student.push(obj);
                            this.dosbing.listStudent.push(stud);
                        }else{
                            this.dosenTA.student.push(obj);
                            this.dosenTA.listStudent.push(stud);
                        }
                        return index > res.data.data.length
                    })
                });
        },

        async getDataPenguji(){
            if (this.penguji.data.length > 0) {
                this.penguji.data = []
            }
            let res = await axios.get(`pengajuan-skripsi/dosen/dosen-penguji/jadwal/${this.dataLecturer.key_dosen}`);
            res.data.data.map((peng, index) => {
                let course = {
                    key: peng.key,
                    ruangId: peng.ruangan,
                    no: index +1,
                    jadwal: peng.tgl_ujian+'~'+this.formattedTime(peng.jam_mulai)+' - '+this.formattedTime(peng.jam_selesai),
                    ruangan: peng.rooms,
                    jumlah: peng.count_siswa
                };
                this.penguji.data.push(course)
            })
        },

        formattedDate(dates) {
            // Mendapatkan tanggal
            const parts = dates.split('-');
            const year = parseInt(parts[0]);
            const month = parseInt(parts[1]);
            const day = parseInt(parts[2]);

            // Array nama hari dan nama bulan
            const days = ['Minggu', 'Senin', 'Selasa', 'Rabu', 'Kamis', 'Jumat', 'Sabtu'];
            const months = ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'];

            // Mendapatkan nama hari
            const dateObj = new Date(year, month - 1, day);
            const dayName = days[dateObj.getDay()];

            // Mendapatkan nama bulan
            const monthName = months[month - 1];

            // Mengembalikan tanggal yang diformat
            // return `${dayName}, ${day} ${monthName} ${year}`;
            return `${dayName}, ${day} ${monthName}`;
        },

        formattedTime(times) {
            // Mendapatkan waktu
            const timeParts = times.split(':');
            const hour = timeParts[0];
            const minute = timeParts[1];

            // Mengembalikan waktu yang diformat
            return `${hour}:${minute}`;
        },

        isValidDate(dateString) {
            const regExp = /^\d{4}-\d{2}-\d{2}$/;
            return regExp.test(dateString);
        },

        async getDataAkademik(){
            if (this.dosbing.data.length > 0) {
                this.dosbing.data = []
            }
            await axios.get(`pengajuan-skripsi/dosen/dosen-pembimbing`)
                .then(res => {
                    res.data.data.map((akademik, index) => {
                        let datas = {
                            key: akademik.key,
                            no: index + 1,
                            angkatan: akademik.nama_angkatan,
                            prodi: akademik.program_name,
                            komkel: akademik.nama_kelompok,
                            key_student: akademik.key_student,
                            nama: akademik.name,
                            nim: akademik.nim,
                            pangkat: akademik.nama_pangkat,
                            action: false,
                        };
                        this.dosbing.data.push(datas);
                    })
            });
        },

        async getDataTA(tahun){
            if (this.dosenTA.data.length > 0) {
                this.dosenTA.data = []
            }
            await axios.get(`master/penugasan-dosen/penugasan-pembimbing-tugas-akhir/${this.dataLecturer.key_dosen}/${tahun}`)
                .then(res => {
                    res.data.data.map((TA, index) => {
                        let data = {
                            key: TA.key,
                            no: index + 1,
                            angkatan: TA.nama_angkatan,
                            prodi: TA.program_name,
                            komkel: TA.nama_kelompok,
                            key_student: TA.key_student,
                            nama: TA.name,
                            nim: TA.nim,
                            pangkat: TA.nama_pangkat,
                        };
                        this.dosenTA.data.push(data);
                    });
            });
        },

        // changeAkademik(value) {
        //     this.selectedTahunTA = value
        //     this.getDataBimbinganTA();
        // },

        async getDataDosBing(){
            if (this.dosbing.data.length > 0) {
                this.dosbing.data = []
            }
            await axios.get(`pengajuan-skripsi/dosen/dosen-pembimbing`)
                .then(res => {
                    res.data.data.map((dosbing, index) => {
                        let data = {
                            no: index+1,
                            nim: dosbing.nim,
                            nama: dosbing.name,
                            angkatan: dosbing.angkatan,
                            judul: dosbing.judul,
                            file: dosbing.lampiran,
                            jadwal: dosbing.tanggal_ujian,
                            penguji: dosbing.dosen_penguji.map((dosen, index) => index+1+'. '+dosen.nama_penguji).join('~')
                        };
                        this.dosbing.data.push(data);
                    });
            });
        },

        async redirectToDetail(key){
            let url = this.$router.resolve({path: `/tugas-akhir/detail/${key}`})
            window.open(url.href);
        },

        // async changeTahun(selected) {
        //     this.selectedTahun = selected
        //     await this.getDataMatkul(selected);
        //     await this.getDataAkademik(selected);
        //     await this.getDataTA(selected);
        //     // await this.getDataAngkatan(selected);
        //     // await this.getDataProdi();
        // },
        
        async changeTahunMatkul(selected) {
            this.selectedTahunMatkul = selected
            await this.getDataMatkul(selected);
        },

        async changeTahunAkademik(selected) {
            this.selectedTahunAkademik = selected
        },

        changeTahunTA(selected) {
            this.selectedTahunTA = selected
            this.getDataBimbinganTA();
        },

        changeAngkatan(index, selected, text) {
            if (text == 'akademik') {
                this.dosbing.data[index].angkatan = selected;
                this.dosbing.data[index].prodi = null;
                this.dosbing.data[index].komkel = null;
                this.dosbing.data[index].nama = null;
                this.dosbing.data[index].key_student = null;
                this.dosbing.data[index].nim = null;
                this.dosbing.data[index].pangkat = null;
            }else{
                this.dosenTA.data[index].angkatan = selected
                this.dosenTA.data[index].prodi = null;
                this.dosenTA.data[index].komkel = null;
                this.dosenTA.data[index].key_student = null;
                this.dosenTA.data[index].nim = null;
                this.dosenTA.data[index].pangkat = null;
            }
        },
        
        changeProdi(index, selected, text) {
            if (text == 'akademik') {
                this.dosbing.data[index].prodi = selected;
                this.dosbing.data[index].komkel = null;
                this.dosbing.data[index].nama = null;
                this.dosbing.data[index].key_student = null;
                this.dosbing.data[index].nim = null;
                this.dosbing.data[index].pangkat = null;
                this.getDataKelas(selected);
            }else{
                this.dosenTA.data[index].prodi = selected;
                this.dosenTA.data[index].komkel = null;
                this.dosenTA.data[index].key_student = null;
                this.dosenTA.data[index].nim = null;
                this.dosenTA.data[index].pangkat = null;
                this.getDataKelas(selected, '');
            }
        },

        changeKelas(index, selected, text) {
            if (text == 'akademik') {
                this.dosbing.data[index].komkel = selected;
                this.dosbing.data[index].nama = null;
                this.dosbing.data[index].key_student = null;
                this.dosbing.data[index].nim = null;
                this.dosbing.data[index].pangkat = null;
                this.getDataSiswa(this.dosbing.data[index].angkatan,this.dosbing.data[index].prodi,this.dosbing.data[index].komkel, 'akademik');
            }else{
                this.dosenTA.data[index].komkel = selected;
                this.dosenTA.data[index].nama = null;
                this.dosenTA.data[index].key_student = null;
                this.dosenTA.data[index].nim = null;
                this.dosenTA.data[index].pangkat = null;
                this.getDataSiswa(this.dosenTA.data[index].angkatan,this.dosenTA.data[index].prodi,this.dosenTA.data[index].komkel, '');
            }
        },

        changeStudent(index, selected, text) {
            if (text == 'akademik') {
                this.dosbing.data[index].nama = selected
                this.dosbing.data[index].key_student = selected
                var stud = this.dosbing.student.find(std => {return std.key == selected})
                this.dosbing.data[index].nim = stud.nim;
                this.dosbing.data[index].pangkat = stud.nama_pangkat;
            }else{
                this.dosenTA.data[index].nama = selected
                this.dosenTA.data[index].key_student = selected
                var std = this.dosenTA.student.find(std => {return std.key == selected})
                this.dosenTA.data[index].nim = std.nim;
                this.dosenTA.data[index].pangkat = std.nama_pangkat;
            }
        },

        async saveAkademik(index){
            var data = this.dosbing.data[index];
            let dataPost = {
                student: data.nama,
                id_dosen: this.dataLecturer.key_dosen
            }
            let result = await axios.post(`master/penugasan-dosen/post-akademik/`, dataPost);
            if (result.data.meta.code == 200) {
                this.$swal('Berhasil Menambah Data')
                this.getDataAkademik();
                this.dis = false
            }
        },

        async saveTA(index){
            var data = this.dosenTA.data[index];
            let dataPost = {
                student: data.nama,
                id_dosen: this.dataLecturer.key_dosen
            }
            let result = await axios.post(`master/penugasan-dosen/post-tugas-akhir/`, dataPost);
            if (result.data.meta.code == 200) {
                this.$swal('Berhasil Menambah Data')
                this.getDataTA(this.selectedTahunTA);
                this.disTA = false
            }
        },

        async deleteRowAkademik(dataKey, index) {
            try {
                if (dataKey) {
                    this.$swal({
                        title: 'Are you sure?',
                        text: 'You will not be able to recover this item!',
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonText: 'Yes, delete it!',
                        cancelButtonText: 'No, cancel!',
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33'
                    }).then(async (result) => {
                        if (result.value) {
                        // User confirmed, so delete the item
                        let result = await axios.delete(`master/penugasan-dosen/delete-akademik/${dataKey}/`)
                        if (result.data.meta.code == 200) {
                            this.$swal('Berhasil', 'Penugasan Mata Kuliah Berhasil Dihapus!', 'OK');
                            this.$delete(this.dosbing.data, index);
                            this.dis = false;
                        }
                        } else {
                        // User canceled, so do nothing
                        }
                    })
                } else {
                    // if (index > 0) {
                        this.$delete(this.dosbing.data, index);
                        this.dis = false;
                    // }x   
                }
            } catch (err) {
                this.$swal(`Failed`);
            }
        },
        async deleteRowTA(dataKey, index) {
            try {
                if (dataKey) {
                    this.$swal({
                        title: 'Are you sure?',
                        text: 'You will not be able to recover this item!',
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonText: 'Yes, delete it!',
                        cancelButtonText: 'No, cancel!',
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33'
                    }).then(async (result) => {
                        if (result.value) {
                        // User confirmed, so delete the item
                        let result = await axios.delete(`master/penugasan-dosen/delete-tugas-akhir/${dataKey}/`)
                        if (result.data.meta.code == 200) {
                            this.$swal('Berhasil', 'Penugasan Mata Kuliah Berhasil Dihapus!', 'OK');
                            this.$delete(this.dosenTA.data, index);
                            this.dis = false;
                        }
                        } else {
                        // User canceled, so do nothing
                        }
                    })
                } else {
                    // if (index > 0) {
                        this.$delete(this.dosenTA.data, index);
                        this.dis = false;
                    // }x   
                }
            } catch (err) {
                this.$swal(`Failed`);
            }
        },
    },
};
</script>

<style>
    .item-rounded {
        border-radius: 50%; /* Make the div rounded */
        background-color: #f0f0f0; /* Background color */
        padding: 10px; /* Add some padding for the icon */
        display: inline-block; /* Display as inline-block to adjust the width */
    }
    .header-color {
        background-color: #3751E4 !important;
        color: white !important;
        font-size: medium !important;
        font-weight: 500 !important;
    }
    .box-custom {
        background-color: #D9D9D9;
        border-radius: 25px;
        color: blue;
        padding: 4%;
    }
</style>